import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var MessageHeartSVG = function MessageHeartSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M27 3H5a3 3 0 00-3 3v13a3 3 0 003 3h3v6a1 1 0 00.08.38 1 1 0 00.54.54.94.94 0 00.76 0 1 1 0 00.33-.21l6.7-6.71H27a3 3 0 003-3V6a3 3 0 00-3-3zm-6.82 9.87l-4 4.05a.33.33 0 01-.44 0l-4-4.05a2.9 2.9 0 010-4 2.76 2.76 0 013.95 0l.23.24.23-.24a2.76 2.76 0 013.95 0 2.9 2.9 0 01.08 4z"
  }));
};
MessageHeartSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(MessageHeartSVG);